// Plain data (no React) so src/lib/structuredData.js can build the FAQPage
// schema from the same questions the accordion renders without pulling this
// lazily loaded page into the main bundle.
//
// `link` is optional: the accordion turns that phrase inside the answer into
// a link, while the schema keeps the plain sentence.
export const FAQS = [
  {
    question:
      "Does this work in the ChatGPT, Claude, and Gemini browser apps, or just desktop apps?",
    answer:
      "Zero Typing AI works in any app with a text field, so it covers browser-based chat tools as well as native desktop apps.",
  },
  {
    question:
      "Can I dictate a prompt in one language and get a response in another?",
    answer:
      "Zero Typing AI's automatic language detection transcribes what you say accurately; translation and response language depend on the AI tool you're prompting.",
  },
  {
    question:
      "Will it learn my technical vocabulary so prompts transcribe correctly?",
    answer:
      "Yes — the Personal Dictionary stores custom terms so they come through correctly every time you dictate a prompt.",
  },
  {
    question: "Is there a free plan?",
    answer:
      "Yes — ZT Basic includes 15 minutes of transcription per week at no cost. Need help getting set up? Visit the Help Center.",
    link: { label: "Help Center", href: "/help" },
  },
];
